 import axios from "axios";

 export default axios.create({
    baseURL:"https://morideapi.groupeya.com/api/v1",
 })